import React, { useEffect, useState, useMemo } from "react";
import BeefreeSDK from "@beefree.io/sdk";
import {
  BEE_BASE_TEMPLATE,
} from "../../../constants/constants";
import emailEditorService from "../../../service/emailEditorService";

const onFetchTemplate = (template) => {
  return fetch(template).then((response) => response.json());
};

const specialLinks = [
  {
    type: "Action",
    label: "Manage Subscription",
    link: "{{manage_subscription_url}}",
  },
];

const Bee = ({
  baseTemplate,
  onSave,
  onSend,
  onStart,
  onSaveAsTemplate,
  beeConfig,
  jsonTemplate,
  style,
  className,
  setBeePluginAPI,
  onTogglePreview,
  mergeTags,
}) => {
  const [state, setState] = useState({ beePlugin: undefined });

  const updatedMergeTags = mergeTags.map((val) => {
    return { value: `{${val.Header}}`, name: val.accessor };
  });

  const DEFAULT_CONFIGURATION = {
    container: "bee-plugin-container", // Identifies the id of div element that contains BEE Plugin.
    language: "en-US",
    autosave: true,
    mergeTags: updatedMergeTags,
  };

  const templateStr = useMemo(() => JSON.stringify(jsonTemplate), [
    jsonTemplate,
  ]);
  useEffect(
    () => {
      if (state.beePlugin && jsonTemplate) {
        state.beePlugin.load(jsonTemplate);
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    },
    [templateStr]
  );

  const getConfig = () => {
    const beeFinalConfig = {
        ...DEFAULT_CONFIGURATION,
        specialLinks: specialLinks,
        ...beeConfig,
        // mergeTags,
        onSave,
        onSaveAsTemplate,
        onSend,
        onStart,
        onTogglePreview,
      };
    const onError = async function (data) {
      const { code, detail, template } = data;
      switch (code) {
        case 5101:
          const newToken = await emailEditorService.getBeeFreeToken(); // this calls your backend
          state.beePlugin.updateToken(newToken);
          break;
        case 5102:
          try {
            const response = await emailEditorService.getBeeFreeToken();

            const token = response;

            const beeEditor = new BeefreeSDK(token);
            beeFinalConfig.onError = onError;
            beeEditor.start(beeFinalConfig, template);
            setTimeout(() => {
              setState((st) => ({ ...st, beePlugin: beeEditor }));
              setBeePluginAPI(beeEditor);
            }, 1500);
          } catch (error) {
            console.error("Err:", error);
          }

          break;
        default:
          console.error("BEE Plugin Error:", { code, detail, template });
          break;
      }
    };
    beeFinalConfig.onError = onError;
    return beeFinalConfig;
  };

  useEffect(() => {
    console.log("Test Bee Temp")
    const fetchData = async () => {
      const beeFinalConfig = getConfig()
      try {
        const response = await emailEditorService.getBeeFreeToken();

        const token = response;

        const beeEditor = new BeefreeSDK(token);
        const template =
          jsonTemplate ||
          (await onFetchTemplate(baseTemplate || BEE_BASE_TEMPLATE));
        beeEditor.start(beeFinalConfig, template);
        setTimeout(() => {
          setState((st) => ({ ...st, beePlugin: beeEditor }));
          setBeePluginAPI(beeEditor);
        }, 1500);
      } catch (error) {
        console.error("Err:", error);
      }
    };
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <div id="bee-plugin-container" style={style} className={className} />;
};

export default Bee;
